import "./styles.css"
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import TableVisualizationRow from "./TableVisualizationRow/Index";
import { Loading } from "../../Loading/Index";

interface TableProductsProps {
  listTable: IProducts[];
  isLoading: boolean;
}

export default function TableProducts({ listTable, isLoading }: TableProductsProps) {

  const {
    setOptionForm,
  } = useEditOnboarding();

  return (
    <>
      {listTable && listTable.length > 0 ?
        <>
          <table className="tableTaskEvaluation" style={{ minWidth: 800 }} id="tableProducts">
            <thead>
              <tr>
                <th>Classificação</th>
                <th>Nome comercial</th>
                <th>Fabricante</th>
                <th />
              </tr>
            </thead>

            <tbody>
              {listTable.map(product =>
                <TableVisualizationRow product={product} />
              )}
            </tbody>

            {isLoading && (
              <div className="tableLoadingOverlay" style={{ minWidth: 1400 }}>
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
          </table>
        </>
        :
        isLoading
          ?
          <div className="emptyTable_container">
            <Loading visible={isLoading} />
          </div>
          :
          <div className="emptyTable_container">
            <span>cadastre seu primeiro produto</span>
            <div
              className="addProduct_button"
              onClick={() => {
                setOptionForm("create-products")
              }}
            >
              <PlusIcon />
              <span>cadastrar produto</span>
            </div>
          </div>
      }
    </>
  )
}